import MainContent from "./MainContent";
import {useContext, useEffect, useRef} from "react";
import {MapContext} from "../context/MapContext";
import {Sheet} from "react-modal-sheet";
import SettingsSheet from "./SettingsSheet";

const snapPoints = [0, 0.12, 0.5, 1]
const statusToSnap = {close: 1, open: 2, full: 3}
const snapToStatus = ['close', 'close', 'open', 'full']

const Panel = ({locations}) => {
  const {panelStatus, setPanelStatus, featuredMarker} = useContext(MapContext)
  const sheetRef = useRef(null)
  const isSheetOpen = featuredMarker === null
  const snapIndex = statusToSnap[panelStatus] ?? 2

  const handleHeaderKeyDown = event => {
    let nextIndex = snapIndex
    if (event.key === 'ArrowUp') nextIndex = Math.min(snapIndex + 1, 3)
    else if (event.key === 'ArrowDown') nextIndex = Math.max(snapIndex - 1, 1)
    else if (event.key === 'Home') nextIndex = 1
    else if (event.key === 'End') nextIndex = 3
    else return

    event.preventDefault()
    setPanelStatus(snapToStatus[nextIndex])
  }

  useEffect(() => {
    if (!isSheetOpen) return
    sheetRef.current?.snapTo(snapIndex)
  }, [isSheetOpen, snapIndex])

  return <>
    <Sheet
      ref={sheetRef}
      isOpen={isSheetOpen}
      onClose={() => setPanelStatus('close')}
      onSnap={index => setPanelStatus(snapToStatus[index])}
      snapPoints={snapPoints}
      initialSnap={snapIndex}
      detent="full"
      disableDismiss
      disableScrollLocking
      unstyled
    >
      <Sheet.Container className={`panel${panelStatus === 'full' ? ' panel-full' : ''}`}>
        <Sheet.Header
          className="panel-header"
          role="slider"
          tabIndex={0}
          aria-label="Altura del panel"
          aria-orientation="vertical"
          aria-valuemin={1}
          aria-valuemax={3}
          aria-valuenow={snapIndex}
          aria-valuetext={panelStatus === 'close' ? 'Mínima' : panelStatus === 'full' ? 'Completa' : 'Parcial'}
          onKeyDown={handleHeaderKeyDown}
        >
          <div className="panel-grabber" aria-hidden="true"/>
        </Sheet.Header>
        <Sheet.Content className="panel-content" disableDrag>
          <MainContent locations={locations} collapsed={panelStatus === 'close'}/>
        </Sheet.Content>
      </Sheet.Container>
    </Sheet>
    <SettingsSheet/>
  </>
}

export default Panel
